<template>
    <div class="keyfeature-mobile-slide-item w-full relative max-w-720px text-white">
        <div class="keyfeature-mobile-slide-inner flex flex-no-wrap w-full ">
            <KeyFeatureItemsDesktop :featureItem="featureItem" v-for="(featureItem, i) in keyfeaturesMobile.keyfeatureDesktopList" :key="i"/>
        </div>
    </div>
</template>

<script>
    import KeyFeatureItemsDesktop from "../sections/services/keyfeatures/KeyFeatureItemsDesktop";

    export default {
        name: "KeyfeatureSliderMobile",
        props: ['keyfeaturesMobile'],
        components: {
            KeyFeatureItemsDesktop,
        },
    }
</script>

<style scoped>

</style>